import request from '@/utils/request';

export default async function newOpenMenu(params, method = 'POST') {
  return request('/menulogs', {
    method,
    body: {
      ...params,
    },
  });
}
